import React, { Component } from 'react';
import { formatEuro } from '../../lib/Formatter';
import { ActivateDisableGameButton } from '../ActivateDisableGameButton';
import Icon from '../Icon';
import ServerTable from '../ServerTable';

class GamesTable extends Component {
	render() {
		const {
			paginatedGames,
			page,
			setQueryState,
			showLastDecision,
			onClickResetGame,
			editGame,
			removeData
		} = this.props;
		const orangeBox = (
			<div
				style={{
					width: '12px',
					height: '12px',
					borderRadius: '2px',
					backgroundColor: '#f5a623'
				}}
			/>
		);
		const circleBox = (
			<div
				style={{
					width: '12px',
					height: '12px',
					borderRadius: '50%',
					backgroundColor: '#f5a623',
					margin: '0 5px 0 0'
				}}
			/>
		);
		const headers = [
			{
				content: 'name',
				width: '22%'
			},
			{
				content: 'team',
				width: '13%'
			},
			{
				content: 'coordinator',
				width: '12%',
				style: { justifyContent: 'center', display: 'flex' }
			},
			{
				content: 'subm.',
				width: '8%',
				style: { justifyContent: 'center', display: 'flex' }
			},
			{
				content: 'completed',
				width: '8%',
				style: { justifyContent: 'center', display: 'flex' }
			},
			{
				content: 'hearts',
				width: '10%',
				style: { justifyContent: 'center', display: 'flex' }
			},
			{
				content: 'money',
				width: '14%'
			},
			{
				content: '',
				width: '20%'
			}
		];
		const tooltip = (label, icon, onClick) => (
			<div className="ServerTable-tooltipButton">
				<span className="ServerTable-tooltip">{label}</span>
				<button onClick={onClick} className="ServerTable-iconButton">
					<Icon icon={icon} />
				</button>
			</div>
		);
		const data = paginatedGames
			? paginatedGames.edges.map(game => [
				{ content: game.data.name },
				{ content: game.data.team },
				{
					content: game.data.leader ? orangeBox : '',
					style: { justifyContent: 'center', display: 'flex' }
				},
				{
					content: game.data.lastSubmission,
					style: { justifyContent: 'center', display: 'flex' }
				},
				{
					content: game.data.state === 'COMPLETED' ? circleBox : '',
					style: { justifyContent: 'center', display: 'flex' }
				},
				{
					content: (
						<div>
							<Icon icon={'heartOrange'} /> {game.data.hearts}
						</div>
					)
				},
				{ content: formatEuro(game.data.money) },
				{
					content: (
						<span
							className="ServerTable-column ServerTable-column--actions"
							style={{
								display: 'flex',
								justifyContent: 'space-between',
								margin: '0px 20px 0px auto',
								width: '100%'
							}}>
							{game.data.cashDecisions &&
								tooltip('Show last decision', 'comment', () =>
									showLastDecision(game.id)
								)}
							{
								<div className="ServerTable-tooltipButton">
									<span className="ServerTable-tooltip">Ignore session expiration date</span>
									<ActivateDisableGameButton
										gameID={game.id}
										status={(game.ignoreExpiration === true)
											? 'disableGame' 
											: 'activateGame'
										} 
									/>
								</div>
									
								}
							{tooltip('Reset', 'repeat', () => onClickResetGame(game.id))}
							{tooltip('Edit user', 'edit', () => editGame(game.id))}
							{tooltip('Remove', 'trash', () => removeData(game.id))}
						</span>
					)
				}
			])
			: [];

		return (
			<ServerTable
				headers={headers}
				data={data}
				page={page}
				totalPages={
					paginatedGames ? paginatedGames.paginationInfo.pageCount : 1
				}
				changePage={page => setQueryState({ gamePage: page })}
			/>
		);
	}
}

export default GamesTable;
